import { apiService } from '@/core/infrastructure/services/apiServiceFactory'
import type { ISchoolMonitoringGroupRepository } from '@/core/domain/school/group/ISchoolMonitoringGroupRepository'
import SchoolMonitoringGroup, {
  SchoolMonitoringGroupInput
} from '@/core/domain/school/group/SchoolMonitoringGroup'

export class SchoolMonitoringGroupRepository implements ISchoolMonitoringGroupRepository {
  async createSchoolMonitoringGroup(
    schoolId: number,
    periodId: number,
    classroomId: number
  ): Promise<SchoolMonitoringGroup> {
    const response = await apiService.post(
      `admin/schools/${schoolId}/periods/${periodId}/classrooms/${classroomId}/monitoring-groups`
    )
    return SchoolMonitoringGroup.create(response.data)
  }

  async updateSchoolMonitoringGroup(
    schoolId: number,
    periodId: number,
    classroomId: number,
    groupId: number,
    group: SchoolMonitoringGroupInput
  ): Promise<SchoolMonitoringGroup> {
    const response = await apiService.put(
      `admin/schools/${schoolId}/periods/${periodId}/classrooms/${classroomId}/monitoring-groups/${groupId}`,
      group
    )
    return SchoolMonitoringGroup.create(response.data)
  }

  async deleteSchoolMonitoringGroup(
    schoolId: number,
    periodId: number,
    classroomId: number,
    groupId: number
  ): Promise<void> {
    await apiService.delete(
      `admin/schools/${schoolId}/periods/${periodId}/classrooms/${classroomId}/monitoring-groups/${groupId}`
    )
  }

  async fetchSchoolMonitoringGroup(
    schoolId: number,
    schoolPeriodId: number,
    schoolClassroomId: number,
    groupId: number
  ): Promise<SchoolMonitoringGroup> {
    throw new Error('Method not implemented.')
  }

  async updateSchoolMonitoringGroupUsers(
    schoolId: number,
    schoolPeriodId: number,
    schoolClassroomId: number,
    schoolMonitoringGroupId: number,
    schoolMonitoringGroup: SchoolMonitoringGroupInput
  ): Promise<SchoolMonitoringGroup> {
    const response = await apiService.put(
      `admin/schools/${schoolId}/periods/${schoolPeriodId}/classrooms/${schoolClassroomId}/monitoring-groups/${schoolMonitoringGroupId}/users`,
      schoolMonitoringGroup
    )
    return SchoolMonitoringGroup.create(response.data)
  }
}
